import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { DollarSign } from "lucide-react";

export const LoanDialog = ({
  open, onOpenChange,
  loanAmount, setLoanAmount,
  loanInterestRate, setLoanInterestRate,
  loanFromTill, setLoanFromTill,
  onAddLoan,
}) => {
  const amt = parseFloat(loanAmount) || 0;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-amber-700">
            <DollarSign className="h-5 w-5" /> Process Loan
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <label className="text-xs font-medium text-gray-500 uppercase">Loan Amount (R)</label>
            <Input
              type="number" step="0.01" min="0"
              placeholder="e.g. 500.00"
              value={loanAmount}
              onChange={(e) => setLoanAmount(e.target.value)}
              className="mt-1 text-lg" autoFocus
              data-testid="loan-amount-input"
              onKeyDown={(e) => e.key === 'Enter' && onAddLoan()}
            />
          </div>
          <div className="flex items-center gap-2">
            <label className="text-xs font-medium text-gray-500 uppercase">Interest Rate (%)</label>
            <Input
              type="number" step="0.5" min="0" max="100"
              value={loanInterestRate}
              onChange={(e) => setLoanInterestRate(parseFloat(e.target.value) || 0)}
              className="w-20 text-center h-8"
              data-testid="loan-rate-input"
            />
          </div>
          <div>
            <label className="text-xs font-medium text-gray-500 uppercase mb-2 block">Where does the cash come from? *</label>
            <div className="grid grid-cols-2 gap-2">
              <button type="button" onClick={() => setLoanFromTill(true)}
                className={`p-3 rounded-lg border-2 text-center transition-all ${loanFromTill === true ? 'border-amber-500 bg-amber-50 ring-2 ring-amber-200' : 'border-gray-200 hover:border-gray-300'}`}
                data-testid="loan-source-till">
                <div className="font-semibold text-sm">{loanFromTill === true ? '✓ ' : ''}TILL</div>
                <div className="text-[10px] text-gray-500">Affects cash-up</div>
              </button>
              <button type="button" onClick={() => setLoanFromTill(false)}
                className={`p-3 rounded-lg border-2 text-center transition-all ${loanFromTill === false ? 'border-green-500 bg-green-50 ring-2 ring-green-200' : 'border-gray-200 hover:border-gray-300'}`}
                data-testid="loan-source-safe">
                <div className="font-semibold text-sm">{loanFromTill === false ? '✓ ' : ''}BACK SAFE</div>
                <div className="text-[10px] text-gray-500">Till not affected</div>
              </button>
            </div>
          </div>
          {amt > 0 && (
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 space-y-1">
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">Principal:</span>
                <span className="font-mono">R {amt.toFixed(2)}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">Interest ({loanInterestRate}%):</span>
                <span className="font-mono text-amber-700">R {(amt * loanInterestRate / 100).toFixed(2)}</span>
              </div>
              <div className="flex justify-between text-base font-bold border-t border-amber-300 pt-1 mt-1">
                <span>Total to Account:</span>
                <span className="text-amber-800 font-mono">R {(amt * (1 + loanInterestRate / 100)).toFixed(2)}</span>
              </div>
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onAddLoan} disabled={!loanAmount || amt <= 0 || loanFromTill === null}
            className="bg-amber-600 hover:bg-amber-700" data-testid="loan-add-btn">
            Add Loan to Cart
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
